export default __webpack_public_path__ + "static/media/Mark-2-Suit-03.096599a4.jpg";